import React, {memo} from 'react';
import {isEqual, orderBy} from 'lodash';
import styled from 'styled-components';
import EvidenceItem from './EvidenceItem';
import {currentResource} from '../../../../util/utils';

function Evidence({evidences = [], engagementId, documentsSignOff, onDocumentSignOffChange}) {
	return (
		<StyledEvidence className="StyledEvidence">
			{evidences.length !== 0 ? (
				orderBy(evidences, ['documentName'], ['asc']).map((document) => {
					return (
						<EvidenceItem
							key={document.id}
							engagementId={engagementId}
							document={document}
							documentsSignOff={documentsSignOff}
							onDocumentSignOffChange={onDocumentSignOffChange}
						/>
					);
				})
			) : (
				<section className="no-documents-available">{currentResource.handOffModal.noDocumentsAvailable}</section>
			)}
		</StyledEvidence>
	);
}

export default memo(Evidence, isEqual);

const StyledEvidence = styled.section`
	display: flex;
	flex-direction: column;
	width: 100%;

	.no-documents-available {
		display: flex;
		width: 100%;
		justify-content: center;
		align-content: center;
		font-size: var(--px-14);
		padding: var(--px-20);
	}
`;
